import { Timestamp } from 'firebase/firestore';

export function convertTimestampToDate(timestamp: Timestamp | null): string {
    if (timestamp instanceof Timestamp) {
        return timestamp.toDate().toLocaleString();
    }
    return ''; // Devuelve una cadena vacía si el timestamp es null o no es un Timestamp válido
}

export function convertTimestampToMillis(timestamp: Timestamp | null): number | null {
    return timestamp ? timestamp.toMillis() : null;
}